export const localization = {
  pt: {
    title: 'Aumente a precisão das respostas durante o atendimento',
    description: 'Adote o modelo que instrui o Agente a responder com texto, imagem, vídeo, áudio, PDF e links.',
    button: 'Baixar modelo',
  },
  en: {
    title: 'Improve response accuracy during conversations',
    description: 'Use the template that guides the Agent to reply with text, images, videos, audio, PDFs, and links.',
    button: 'Download template',
  },
  es: {
    title: 'Mejora la precisión de las respuestas durante la atención',
    description: 'Utiliza la plantilla que guía al Agente para responder con texto, imágenes, videos, audio, archivos PDF y enlaces.',
    button: 'Descargar plantilla',
  },
};
